import { BrandVariants, createLightTheme, createDarkTheme } from '@fluentui/react-components';

const wbdBrand: BrandVariants = {
  10:  '#001226',
  20:  '#001a36',
  30:  '#001e3e',
  40:  '#00254a',
  50:  '#002c56',
  60:  '#003057',  // WBD Blue
  70:  '#003d6e',
  80:  '#004d85',
  90:  '#005e9d',
  100: '#0070b5',
  110: '#1981c5',
  120: '#3594d1',
  130: '#52a6db',
  140: '#70b8e4',
  150: '#90cced',
  160: '#b5dff4',
};

export const wbdLightTheme = createLightTheme(wbdBrand);
export const wbdDarkTheme  = createDarkTheme(wbdBrand);
